interface VideoViewerProps {
  url: string;
  contentType?: string;
  // Accepted for prop-compatibility with the other viewers; videos have no
  // download endpoint yet, so the prop is unused here.
  onDownload?: () => void;
}

export default function VideoViewer({
  url,
  contentType = 'video/mp4',
}: VideoViewerProps) {
  return (
    <video height="100%" controls>
      <source src={url} type={contentType} />
      <track default kind="captions" />
    </video>
  );
}
